const Resources = {

    table_headers: [
        { 
          text:     'Description',
          align:    'start',
          value:    'description'
        }
    ],
    
    breadcrumb:[
        {
            name:   'Home',
            href:   '/',
            arrow:  "<span class='slash'>/</span>",
        },
        {
            name:   'Options',
            href:   '#',
            arrow:  "<span class='slash'>/</span>",
        },
        {
            name:   'Time Off',
            href:   '/options-time-off',
            arrow:  "",
        },
    ],

}

export default Resources;